import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { Device } from 'src/app/_models/device';
import { getConvertedTimeStringFromMs } from 'src/app/_helpers/utils';
import { DeviceSetupStatus } from 'src/app/_models/device-setup-status';
import { Experiment } from 'src/app/_models/experiment';
import { SmallDataCardComponent } from '../small-data-card/small-data-card.component';
import { IconButtonComponent } from '../../buttons/icon-button/icon-button.component';
import { BasicCardComponent } from '../basic-card/basic-card.component';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { StatusIndicatorComponent } from '../../chips/status-indicator/status-indicator.component';
import { DeviceSetupStatusDisplay } from 'src/app/_models/device-setup-status';

@Component({
    selector: 'app-device-info-card',
    templateUrl: './device-info-card.component.html',
    styleUrls: ['./device-info-card.component.scss'],
    imports: [
        MatIcon,
        BasicCardComponent,
        IconButtonComponent,
        SmallDataCardComponent,
        DatePipe,
        StatusIndicatorComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceInfoCardComponent {
  DeviceStatus = DeviceSetupStatus;

  /** The device to be displayed (required) */
  device = input<Device>();

  /** Experiment object to extract values from per flask (required)  */
  experiment = input<Experiment>();

  /** Time of last fetch */
  lastUpdateTime = input<Date | undefined>(undefined);

  /** Is the pause button disabled (required) */
  buttonDisabled = input<boolean>();

  /** Emitted when pause/resume button is clicked */
  pauseDeviceClicked = output<number>();

  getConvertedTime(timeInMs: number): string {
    // Use utility helper func to convert time in ms to time object and return formatted string
    const timeObject = getConvertedTimeStringFromMs(timeInMs);
    return `${timeObject.days}:${timeObject.hours}:${timeObject.minutes}:${timeObject.seconds}`;
  }

  public get statusClass(): string {
    const indicator = this.device()?.deviceStatusId;
    switch (indicator) {
      case DeviceSetupStatus.Active:
        return DeviceSetupStatusDisplay[DeviceSetupStatus.Active];
      case DeviceSetupStatus.Paused:
        return DeviceSetupStatusDisplay[DeviceSetupStatus.Paused];
      default:
        return '';
    }
  }

  clickButton = (value: number): void => {
    this.pauseDeviceClicked.emit(value);
  };
}
